// src/App.js
import { useCallback } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import NavBar        from './components/NavBar';
import Footer        from './components/Footer';
import Home          from './pages/Home';
import About         from './pages/About';
import HowItWorks    from './pages/HowItWorks';
import ForCitizens   from './pages/ForCitizens';
import ForBusinesses from './pages/ForBusinesses';
import Contact       from './pages/Contact';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy   from './pages/PrivacyPolicy';
import DeleteRequest   from './pages/DeleteRequest';

const PAGE_PATHS = {
  'home':           '/',
  'about':          '/About',
  'how-it-works':   '/HowItWorks',
  'for-citizens':   '/ForCitizens',
  'for-businesses': '/ForBusinesses',
  'contact':        '/Contact',
  'terms':          '/TermsConditions',
  'privacy':        '/PrivacyPolicy',
  'delete-request': '/DeleteRequest',
};

const PATH_TO_PAGE = Object.fromEntries(
  Object.entries(PAGE_PATHS).map(([id, path]) => [path, id])
);

export default function App() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const page = PATH_TO_PAGE[pathname] || 'home';

  const go = useCallback((id) => {
    navigate(PAGE_PATHS[id] || '/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [navigate]);

  return (
    <div style={{ display:'flex', flexDirection:'column', minHeight:'100vh' }}>
      <NavBar page={page} go={go} />
      <main style={{ flex:1 }}>
        <Routes>
          <Route path="/"                element={<Home           go={go} />} />
          <Route path="/About"           element={<About                  />} />
          <Route path="/HowItWorks"      element={<HowItWorks     go={go} />} />
          <Route path="/ForCitizens"     element={<ForCitizens    go={go} />} />
          <Route path="/ForBusinesses"   element={<ForBusinesses  go={go} />} />
          <Route path="/Contact"         element={<Contact                />} />
          <Route path="/TermsConditions" element={<TermsConditions go={go} />} />
          <Route path="/PrivacyPolicy"   element={<PrivacyPolicy   go={go} />} />
          <Route path="/DeleteRequest"   element={<DeleteRequest           />} />
          <Route path="*"              element={<Home          go={go} />} />
        </Routes>
      </main>
      <Footer go={go} />
    </div>
  );
}